import { render, staticRenderFns } from "./CompositionBreakdown.vue?vue&type=template&id=7929b08b&scoped=true&"
import script from "./CompositionBreakdown.vue?vue&type=script&lang=js&"
export * from "./CompositionBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./CompositionBreakdown.vue?vue&type=style&index=0&id=7929b08b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7929b08b",
  null
  
)

export default component.exports